module.exports = __webpack_public_path__ + "img/10-payslip.b36e7638.png";